(function () {
  if (window.__newsStickyCtaInit) return;
  window.__newsStickyCtaInit = true;

  var getBars = function () {
    return Array.prototype.slice.call(document.querySelectorAll('[data-news-sticky-cta]'));
  };

  var restack = function () {
    var stack = 0;
    getBars().forEach(function (bar) {
      var own = parseInt(bar.dataset.offset, 10) || 0;
      bar.style.bottom = stack + own + 'px';
      if (bar.classList.contains('is-visible')) {
        stack += own + bar.offsetHeight;
      }
    });
    document.documentElement.style.setProperty('--news-fixed-stack', stack + 'px');
    window.dispatchEvent(new CustomEvent('news:fixed-stack', { detail: { height: stack } }));
  };

  var ticking = false;

  var update = function () {
    ticking = false;
    getBars().forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (isNaN(threshold)) threshold = 400;
      bar.classList.toggle('is-visible', window.scrollY > threshold);
    });
    restack();
  };

  var request = function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  };

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });
  update();
})();
